const registerDesign = {
  inputs: [
    {
      type: "text",
      name: "name",
      placeholder: "Enter your full name",
    },
    {
      type: "text",
      name: "age",
      placeholder: "Enter you age",
    },
    {
      type: "text",
      name: "number",
      placeholder: "Enter your contact number",
    },
    {
      type: "text",
      name: "email",
      placeholder: "Enter email ID",
    },
    {
      type: "password",
      name: "password",
      placeholder: "Enter your password",
    },
    {
      type: "radio",
      name: "role",
      value: "supplier",
    },
    {
      type: "radio",
      name: "role",
      value: "customer",
    },
  ],
};

export default registerDesign;
